import styled from 'styled-components';
import tw from 'twin.macro';

export const CardContainer = styled.div`
  ${tw`mt-10 flex flex-col items-center justify-center text-center`};
`;

export const SuccessHeading = styled.p`
  ${tw`text-2xl leading-8 font-semibold mb-4 mt-4 font-inter text-blue-gray-500`};
  @media (max-width: 768px) {
    ${tw`text-lg leading-7 mt-6`}
  }
`;

export const SubHeadingText = styled.p`
  ${tw`text-base leading-6 font-medium mb-4 font-inter text-blue-gray-600`};
  @media (max-width: 768px) {
    ${tw`text-sm leading-5`}
  }
`;

export const SubHeadingText2 = styled(SubHeadingText)`
  ${tw`mb-4`}
`;

export const SlotBookingContainer = styled.div`
  ${tw`border border-dashed p-6 flex flex-col items-center border-blue-gray-400 rounded-lg`};
`;

export const SlotIsBookedForYouText = styled.p`
  ${tw`text-sm leading-5 font-semibold mb-3 font-inter text-blue-gray-600`};
`;

export const TimeSlotText = styled.p`
  ${tw`ml-1 text-sm leading-5 font-semibold mb-3 font-inter text-blue-gray-600`};
`;

export const TimeSlotIconWrapper = styled.div`
  ${tw`flex`}
`;

export const DateSlotWrapper = styled.div`
  ${tw`mr-8 flex items-center`}
`;

export const SecondRowWrapper = styled.div`
  ${tw`flex`}
`;

export const IconContainer = styled.div`
  ${tw`flex justify-center items-center`}
`;
